// extracted by mini-css-extract-plugin
module.exports = {"overlay":"UJ-gPE"};